import { render, staticRenderFns } from "./innovationCenNav.vue?vue&type=template&id=01b38f6a&scoped=true"
import script from "./innovationCenNav.vue?vue&type=script&lang=js"
export * from "./innovationCenNav.vue?vue&type=script&lang=js"
import style1 from "./innovationCenNav.vue?vue&type=style&index=1&id=01b38f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b38f6a",
  null
  
)

export default component.exports